import * as React from "react";
import Tooltip from "@mui/material/Tooltip";
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import CancelIcon from "@mui/icons-material/Cancel";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import { ButtonGroup, Chip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Header from "../Includes/Header";
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import { useEffect, useRef } from "react";
import { DialogContentText } from "@mui/material";
import { EditText } from 'react-edit-text';
import 'react-edit-text/dist/index.css';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'; // Example icon

import {
  Card,
  Button,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Paper,
  TablePagination,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Menu from "@mui/material/Menu";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import CircularProgress from "@mui/material/CircularProgress";
import RefreshIcon from "@mui/icons-material/Refresh";
import json2mq from "json2mq";
import {
  AutocompleteAdminUser,
  StatusAdminUser,
  UpdateAdminUser,
} from "../Apihelper/ApiHelperUser";
import {
  
  DeleteOfferpackageUser,
  DueOfferpackageUser,
  AutocompleteNonUser,
} from "../Apihelper/ApiOfferPackage";
import {
    retrieveCheckindata,
    Manualcheckout,
    StoreBiometric,
  } from "../Apihelper/AttendanceHelper";

import { useNavigate } from "react-router-dom";
import AppToast from '../../components/Toast/AppToast';

const useStyles = styled((theme) => ({
  tableContainer: {
    maxWidth: 600,
    margin: "0 auto",
  },
  table: {
    display: "none", // Hide the table on all screens
    [theme.breakpoints.down("sm")]: {
      display: "table", // Show the table on small screens only (mobile view)
    },
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide the card container on small screens (mobile view)
    },
  },
  card: {
    width: "100%",
    margin: "8px",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "300px", // Adjust the card width as needed
    },
  },
}));
const drawerWidth = 292;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 'bold',
    borderBottom: 'none',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#f9f9f9',
  },
  '&:hover': {
    backgroundColor: 'rgba(31, 122, 84, 0.08)',
    cursor: 'pointer',
  },
}));

function AttendanceMember(props) {
  const { colors: appColors } = useAppTheme();
  const navigate = useNavigate();
  const { window1, onTotalChange } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [status, setstatus] = useState("");
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [Role, setRole] = useState("");
  const [openToast, setOpenToast] = useState(false);
  const [options, setOptions] = useState([]);
  const [deleteConfirmationId, setDeleteConfirmationId] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Default to 'success'
  const [fetchdatarow, setetchdatarow] = useState([]); // Default to 'success'
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const dateRef = useRef();
  const [age, setAge] = React.useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [opendue, setOpendue] = useState(false);
  const [selectedDue, setSelectedDue] = useState(null); // To store the current due value for the modal
  const [inputValue, setInputValue] = useState(''); // Input value in modal
  const [currentRowId, setCurrentRowId] = useState(null); // To store the current row id for handling due change

  // Open modal if due is greater than 0
  const handleOpendue = (id, due) => {
    if (due > 0) {
      setOpendue(true);
      setSelectedDue(due);
      setCurrentRowId(id);
    }
  };
  // Close modal

  const handleClosedue = () => {
    setOpendue(false);
    setInputValue('');
  };
  // Handle input change
  const handleInputChangedue = (event) => {
    let value = event.target.value;

    // Ensure the value is within the allowed range (min = 0, max = selectedDue)
    if (value > selectedDue) {
      value = selectedDue; // Limit the value to the maximum (due amount)
    } else if (value < 0) {
      value = 0; // Prevent negative values
    }

    setInputValue(value);
  };

  // Handle submit
 


  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);


  const handleToastClose = () => {
    setOpenToast(false);
  };
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };
  const container =
    window1 !== undefined ? () => window().document.body : undefined;

  // useEffect(() => {
  //   // Perform localStorage action
  //   const item = localStorage.getItem('userdata')
  //   if (item ==null){
  //      setredirectpage(true);
  //   }
  //   //console.log("tapan"+item);
  // }, [])
  // if (redirectpage) {

  //   return redirect('/');
  // }



  const handleCancel = () => {
    setOpenConfirmation(false);
  };
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [dueValues, setDueValues] = useState([]); // Initialize state for due values
  const [adddueValues, setaddDueValues] = useState([100, 50, 75]);
 
  const fetchData = async (value = "", newPage = 0, newRowsPerPage = 10) => {
    setLoading(true);
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const searchText = value;
      const limit = newRowsPerPage;
      const index = newPage * newRowsPerPage;
      const members = "members";

      const res = await retrieveCheckindata(
        userToken,
        "",
        members,
        searchText,
        limit,
        index
      );

      if (res.code === 200) {
        if (res.data && res.data.length > 0) {
          setetchdatarow(res.data);
          setDueValues(res.data.map(row => row.due));
        } else {
          setetchdatarow([]);
          handleSnackbarOpen("No Record Found", "warning");
        }
        const count = res.total_count ?? 0;
        setTotalCount(count);
        if (onTotalChange) onTotalChange(count);
      }
    } catch (error) {
      console.error(error);
      handleSnackbarOpen("Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData("", page, rowsPerPage);
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchData("", newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    fetchData("", 0, newRowsPerPage);
  };

  const handleSearchChange = (event, value) => {
    const searchText = value || ""; // If value is undefined or empty, set searchText to empty string
    // setSearchText(searchText);
    // Call fetchData function here with the updated searchText
    fetchData(searchText);
  };

  const handleDelete = (id) => {
    handleClose();
    setDeleteConfirmationId(id);
    setOpenDeleteConfirmation(true, id);
  };
  React.useEffect(() => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      // User is not logged in, no need to redirect
      navigate('/');
    }
    
  }, []);

  const handleInputChange = async (value) => {
    if (value.length >= 3) {
      try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id; // Assuming you have a userId in userdata
        const searchText = value; // Example search text

        const res = await AutocompleteNonUser(userToken, userId, searchText);

        if (res.code == "200") {
          const names = res.data.map((item) => item.search_text);
          setOptions(names);
        } else {
          handleSnackbarOpen(res.message, "error");
          //  console.error(error); // Handle error
        }
      } catch (error) {
        console.error(error);
        // Handle errors
      }
    }
  };
  const handleCheckout = async (id) => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;

      const response = await Manualcheckout(userToken, id);
      if (response.code == "200") {
        handleSnackbarOpen(response.message, "success");
        fetchData();
      } else {
        handleSnackbarOpen(response.message, "error");
        //  console.error(error); // Handle error
      }
    } catch (error) {
      console.error("Checkout Error:", error.message);
    }
  };
  
  const handleRefresh = async() => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;

      const response = await StoreBiometric(userToken);
      if (response.code == "200") {
        handleSnackbarOpen(response.message, "success");
        fetchData();
      } else {
        handleSnackbarOpen(response.message, "error");
        //  console.error(error); // Handle error
      }
    } catch (error) {
      console.error("Checkout Error:", error.message);
    }
   
  };
  return (
      <Box sx={{
        width: '100%',
        p: { xs: 1, sm: 2, md: 3 },

      }}>
        {/* Header Section */}
        <Box sx={{ 
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'stretch', sm: 'center' },
          gap: 2,
          mb: 2
        }}>
          <Typography variant="h5" sx={{ fontWeight: 600, color: appColors.leaf }}>
            Members
          </Typography>
          <Button
            variant="contained"
            onClick={handleRefresh}
            startIcon={<RefreshIcon />}
            fullWidth={true}
            sx={{
              bgcolor: appColors.leaf,
              '&:hover': { bgcolor: appColors.pine },
              maxWidth: { sm: '200px' }
            }}
          >
            Refresh
          </Button>
        </Box>

        {/* Search Section */}
        <Box sx={{ mb: 3 }}>
          <Autocomplete
            freeSolo
            disableClearable
            options={options}
            onInputChange={(event, value) => handleInputChange(value)}
            onChange={(event, value) => handleSearchChange(event, value)}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Search Members"
                size="small"
                fullWidth
                InputProps={{
                  ...params.InputProps,
                  type: 'search',
                }}
                sx={{
                  width: { xs: '100%', sm: '300px' },
                  '& .MuiOutlinedInput-root': {
                    bgcolor: 'white',
                  }
                }}
              />
            )}
          />
        </Box>

        {/* Table Section */}
        <Box sx={{ 
          width: '100%',
          overflowX: 'auto',
          mb: 3,
          '& .MuiTableContainer-root': {
            borderRadius: 1,
          }
        }}>
          <TableContainer component={Paper}>
            {loading ? (
              <Box sx={{ textAlign: 'center', p: 4 }}>
                <CircularProgress sx={{ color: appColors.leaf }} />
              </Box>
            ) : (
              <Table sx={{ minWidth: 800 }}>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>S.NO</StyledTableCell>
                    <StyledTableCell>NAME / ID</StyledTableCell>
                    <StyledTableCell>DATE</StyledTableCell>
                    <StyledTableCell>CHECK IN</StyledTableCell>
                    <StyledTableCell>CHECK OUT</StyledTableCell>
                    <StyledTableCell>PHONE</StyledTableCell>
                    <StyledTableCell>STATUS</StyledTableCell>
                    <StyledTableCell>WORK HOURS</StyledTableCell>
                    <StyledTableCell>ACTION</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {fetchdatarow.map((row, indexx) => (
                    <StyledTableRow key={indexx}>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>{page * rowsPerPage + indexx + 1}</TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>
                        {row.user_name}
                        <Box component="span" sx={{ display: 'block', fontSize: '0.75rem', color: 'text.secondary' }}>
                          {row.user_id}
                        </Box>
                      </TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.date}</TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.check_in}</TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.check_out}</TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.phone}</TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>
                        <Chip
                          label={row.status}
                          size="small"
                          sx={{
                            bgcolor: row.status === 'active' 
                              ? 'rgba(16, 185, 129, 0.1)' 
                              : 'rgba(239, 68, 68, 0.1)',
                            color: row.status === 'active' 
                              ? '#10b981' 
                              : '#ef4444',
                            fontWeight: 500,
                          }}
                        />
                      </TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.work_hours}</TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>
                        <Tooltip title="Checkout">
                          <IconButton 
                            onClick={() => handleCheckout(row.id)}
                            size="small"
                            sx={{
                              color: appColors.leaf,
                              '&:hover': {
                                bgcolor: 'rgba(31, 122, 84, 0.08)',
                              },
                            }}
                          >
                            <ShoppingCartIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </TableContainer>
        </Box>

        {/* Pagination */}
        <TablePagination
          component="div"
          count={totalCount}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10, 20, 50]}
          onRowsPerPageChange={handleChangeRowsPerPage}
          showFirstButton
          showLastButton
          sx={{ '& .MuiTablePagination-actions': { mr: 8 } }}
          labelDisplayedRows={({ page: p, count }) =>
            `Page ${p + 1} of ${Math.ceil(count / rowsPerPage)}  |  Total: ${count} records`
          }
        />

        <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
      </Box>
  );
}

export default AttendanceMember;